/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_2Inputs */

const en_cp_give_2 = /** @type {(inputs: Cp_Give_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The 14-week calendar, a rubric per track, AI-use rules for the course contract`)
};

const id_cp_give_2 = /** @type {(inputs: Cp_Give_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender 14 minggu, rubrik per jalur, aturan pakai AI untuk kontrak kuliah`)
};

/**
* | output |
* | --- |
* | "The 14-week calendar, a rubric per track, AI-use rules for the course contract" |
*
* @param {Cp_Give_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_2 = /** @type {((inputs?: Cp_Give_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_2(inputs)
	return en_cp_give_2(inputs)
});